/**
 * SessionManagerWrapper Component
 * Wrapper for Session Manager modal (collaboration sessions)
 */

import React from 'react';
import { SessionManager } from '../collaboration';

export const SessionManagerWrapper = ({
  isOpen,
  onClose,
  currentSessionId,
  onCreateSession,
  onJoinSession,
  onLeaveSession,
  userName,
}) => {
  return (
    <SessionManager
      isOpen={isOpen}
      onClose={onClose}
      currentSessionId={currentSessionId}
      onCreateSession={onCreateSession}
      onJoinSession={onJoinSession}
      onLeaveSession={onLeaveSession}
      userName={userName}
    />
  );
};

export default SessionManagerWrapper;
